package com.patronat.top.ui.molecules.files

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.theme.BodyLarge
import com.patronat.top.ui.theme.MineShaft100
import com.patronat.top.ui.theme.MineShaft500
import com.patronat.top.ui.theme.MineShaft50
import com.patronat.top.ui.theme.MineShaft900
import com.patronat.top.ui.theme.Primary600
import com.patronat.top.ui.theme.White

@Composable
fun FileAttachmentRow(
    fileName: String,
    onRemoveClick: (() -> Unit)?,
    modifier: Modifier = Modifier,
    leadingIcon: Painter? = null,
    trailingIcon: Painter? = null,
    onClick: (() -> Unit)? = null
) {
    val clickableModifier = if (onClick != null) {
        Modifier.clickable { onClick() }
    } else {
        Modifier
    }

    Row(
        modifier = modifier
            .fillMaxWidth()
            .height(60.dp)
            .then(clickableModifier)
            .background(White, RoundedCornerShape(12.dp))
            .border(1.dp, MineShaft100, RoundedCornerShape(12.dp))
            .padding(horizontal = 14.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        if (leadingIcon != null) {
            Box(
                modifier = Modifier
                    .size(30.dp)
                    .background(MineShaft50, RoundedCornerShape(8.dp)),
                contentAlignment = Alignment.Center
            ) {
                Icon(
                    painter = leadingIcon,
                    contentDescription = null,
                    tint = Primary600,
                    modifier = Modifier.size(16.dp)
                )
            }
        }

        Text(
            text = fileName,
            style = BodyLarge,
            color = MineShaft900,
            modifier = Modifier.padding(start = if (leadingIcon != null) 10.dp else 0.dp)
        )

        Spacer(modifier = Modifier.weight(1f))

        if (trailingIcon != null) {
            val removeModifier = if (onRemoveClick != null) {
                Modifier.clickable { onRemoveClick() }
            } else {
                Modifier
            }

            Icon(
                painter = trailingIcon,
                contentDescription = null,
                tint = MineShaft500,
                modifier = removeModifier.size(18.dp)
            )
        }
    }
}
